import React from 'react';

import * as styles from './styles';

import { Button } from '@cobliteam/ui/components';

import { TagIcon } from '../icons';

import { ConfirmationModal, ModalType } from '../ConfirmationModal';
import { NumberInput } from '../Input';
import {
  BodyText,
  CaptionDefault,
  DescriptionListDefault,
  DescriptionTitle,
} from '../typography';

export interface UpsellModalProps {
  onCancel: () => void;
  onConfirm: (numberOfDevices: number) => void;
  isLoading: boolean;
}

export const UpsellModal: React.FC<UpsellModalProps> = ({
  onCancel,
  onConfirm,
  isLoading,
}) => {
  const [numberOfDevices, setNumberOfDevices] = React.useState<number>(0);

  const handleConfirmClick = () => {
    onConfirm(numberOfDevices);
  };

  const updateField = (value?: number) =>
    value ? setNumberOfDevices(value) : setNumberOfDevices(0);

  return (
    <ConfirmationModal
      open
      confirmationButtonProps={{ disabled: !numberOfDevices }}
      onCancel={onCancel}
      onConfirm={handleConfirmClick}
      headerText='Solicitar mais dispositivos'
      buttonText='Confirmar'
      type={ModalType.SUBMIT}
      className={styles.title}
      loading={isLoading}
    >
      <CaptionDefault className={styles.badge}>
        <DescriptionListDefault className={styles.simpleText}>
          Procurando por suporte técnico?
        </DescriptionListDefault>
        <a
          className={styles.buttonFAQ}
          rel='noreferrer'
          href='https://suporte.cobli.co/contato-cobli'
          target='_blank'
        >
          <Button variant='text'>Entre em contato</Button>
        </a>
      </CaptionDefault>
      <BodyText className={styles.grayText}>
        Ao prosseguir com a solicitação, a equipe de Sucesso do cliente entrará
        em contato para dar continuidade ao pedido
      </BodyText>
      <div className='flex pt-5'>
        <TagIcon className={styles.icon} />
        <DescriptionTitle className={styles.grayText}>
          Informações adicionais
        </DescriptionTitle>
      </div>
      <BodyText className={styles.grayText}>
        Informe abaixo a quantidade de dispositivos que deseja incluir na sua
        frota.
      </BodyText>
      <div className={styles.paddingTop}>
        <DescriptionTitle className={styles.grayText}>
          Quantidade de dispositivos:
        </DescriptionTitle>
      </div>
      <NumberInput
        name='numberOfDevices'
        onNumberChange={updateField}
        required
        placeholder='00'
        value={numberOfDevices}
      />
    </ConfirmationModal>
  );
};
